<template>
<!-- 机构管理后台v2 -->
  <ConfigProvider id="app" class="body-container" :locale="locale">
    <router-view v-wechat-title="$route.meta.title"/>
  </ConfigProvider>
</template>

<script>
import cookie from 'vue-cookie' //cookie
import zhCN from 'ant-design-vue/es/locale/zh_CN';
import {ConfigProvider } from 'ant-design-vue';
export default {
  name: 'App',
  components:{ConfigProvider},
  data(){
    return {
      locale:zhCN
    }
  },
  beforeCreate(){
    // cookie.set('WTS_TOKEN_A', this.$config.token, {expires: 1, path: "/", domain: 'wts9999.net',secure: true});
  },
  created(){
    if(!this.check()){
    //   window.location.href = '/apps/index/index'
    }
    const shareData = {
      title: "凤栖云服 开放，见未来",
      link: location.origin,
      content: "国内领先的科技保险服务提供商，专注为企业级客户提供云端保险解决方案。",
      logo: location.origin + '/apps/public/images/logo.png'
    }
    this.$weixin.share(shareData);
  },
  methods:{
  check() {
    var userAgentInfo=navigator.userAgent;
    var Agents =new Array("Android","iPhone","SymbianOS","Windows Phone","iPad","iPod");
    var flag=true;
    for(var v=0;v<Agents.length;v++) {
      if(userAgentInfo.indexOf(Agents[v])>0) {
        flag=false;
        break;
      }
    }
    return flag;
    }
  },
  watch: {
      '$route' (to, from) {
        const toDepth = to.path.split('/').length
        const fromDepth = from.path.split('/').length
      }
    },

}
</script>

<style lang="scss">
  @import "static/iconfont/iconfont.css";
  #app {
    width: 100%;
    min-height: 100%;
    margin: 0 auto;
    // overflow: auto; 产品页佣金出现双重滚动
  }
</style>
